import { ProductMediaApi } from '../openapi';
import { config } from './config';

export const MediaClient = new ProductMediaApi(config);
